/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import React, { Component } from 'react'

import './MemberEditor.css'
import TeamRoleSetter from './TeamRoleSetter'
import TRCInput from '../../../trace/TRCInput'

export default class MemberEditor extends Component {
    constructor(props) {
        super(props)
        this.onUserTitleChanged = this.onUserTitleChanged.bind(this)
        this.onUserEmailChanged = this.onUserEmailChanged.bind(this)
        const user = this.props.user ? this.props.user : {}
        this.state = {
            editState: this.editStateFromUser(user)
        }
        if(props.onChange) {
            props.onChange(this.state.editState)
        }
    }

    editStateFromUser(user) {
        return {
            title: `${user.first_name} ${user.last_name}`,
            email: user.email ? user.email : user.masked_email,
            masked_email: user.masked_email
        }
    }

    setEditState(prop, field) {
        const editState = Object.assign({}, this.state.editState, prop)
        this.setState({editState: editState})
        if(this.props.onChange) {
            this.props.onChange(editState, field)
        }
    }

    componentWillReceiveProps(nextProps) {
        const user = nextProps.user ? nextProps.user : {}
        if(!this.props.user && nextProps.user) {
            this.setEditState(this.editStateFromUser(user))
        }
    }

    caption(field, text) {
        const errors = this.props.errors ? this.props.errors : []
        for(const error of errors) {
            if (error.field === field) {
                return error.error
            }
        }
        return text
    }

    errorClass(field) {
        const errors = this.props.errors ? this.props.errors : []
        for(const error of errors) {
            if (error.field === field) {
                return 'invalid'
            }
        }
        return ''
    }

    render() {
        const editState = this.state.editState
        return (
            <div className="MemberEditor">
                <div className="area">
                    <h4>Name</h4>
                    <div>
                        <TRCInput
                            type="text"
                            className={`team-title ${this.errorClass('title')}`}
                            placeholder="Enter Member's Full Name"
                            name="title"
                            value={editState.title}
                            onChange={this.onUserTitleChanged}
                        />
                    </div>
                    <span className="error">
                        {this.caption('title', '')}
                    </span>
                </div>
                <div className="area">
                    <h4>Email</h4>
                    <div>
                        <TRCInput
                            type="text"
                            className={`team-email ${this.errorClass('email')}`}
                            placeholder="Enter Email Address"
                            name="email"
                            value={editState.email}
                            onChange={this.onUserEmailChanged}
                        />
                    </div>
                    <span className="error">
                        {this.caption('email', '')}
                    </span>
                </div>
                <TeamRoleSetter
                    entries={this.props.members}
                    title="Teams"
                    onRoleChanged={this.props.onMemberRoleChanged}
                />
            </div>
        )
    }

    onUserTitleChanged(e) {
        this.setEditState({ title: e }, 'title')
    }

    onUserEmailChanged(e) {
        this.setEditState({ email: e }, 'email')
    }
}
